export const setVersion = (state, version) => {
  state.version = version; //eslint-disable-line
};
export const setConfig = (state, data) => {
  state.config = data; //eslint-disable-line
};
export const setInit = (state, bool) => {
  state.init = bool; //eslint-disable-line
};
export const setMobile = (state, bool) => {
  state.isMobile = bool; //eslint-disable-line
};

